export default __webpack_public_path__ + "static/media/raro-ameaca.ecd720a2.webp";